export default "__VITE_ASSET__Cykn3uw6__"